import {
    SILENCIUM_RECEIVE,
    SILENCIUM_ERROR,
} from '../bevegoConstants';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    groups: {},
    postUrl: '',
    printUrl: '',
    adjustedInputViewModel: {},
    emptyResultMessage: '',
    filteredResult: [],
    hasFilteredResult: '',
    noiseCalculations: '',
    searchScenarios: {},
    selectedCompetitorResult: {},
    errors: {}
};

export const silencium = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case SILENCIUM_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload
            };
        case SILENCIUM_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            };
        default:
            return state;
    }
};